import React, { useState, useEffect } from "react";
import BASE_URL from "components/BaseUrl/apiConfig";
import { Chart } from "chart.js/auto";
import ChartDataLabels from "chartjs-plugin-datalabels";

Chart.register(ChartDataLabels);



export default function CardBarChart() {
  const [pieData, setPieData] = useState([]);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);

  const storedUserData = localStorage.getItem('userData');
  let userId = '';
  let groupId = '';

  if (storedUserData) {
    const userData = JSON.parse(storedUserData);
    userId = userData.userId;
    groupId = userData.groupId
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${BASE_URL}/api/Analytics/GetExpenseMonthswise?groupId=${groupId}&year=${selectedYear}&months=${selectedMonth}`
        );
        const data = await response.json();
        setPieData(data);
        console.log(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [selectedYear, selectedMonth]);

  useEffect(() => {
    // if (pieData.length === 0) return;




    if (pieData.length === 0) {


      // Destroy the existing chart instance if it exists
      if (window.myPie) {
        window.myPie.destroy();
      }

      // Display a message or handle no data scenario
      const ctx = document.getElementById("pie-chart").getContext("2d");
      ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height); // Clear the canvas
      ctx.fillText("No data found", ctx.canvas.width / 2, ctx.canvas.height / 2);
      return;
    }


    // Destroy the existing chart instance if it exists
    if (window.myPie) {
      window.myPie.destroy();
    }

    // const config = {
    //   type: "pie",
    //   data: {
    //     labels: pieData.map((item) => item.expenseDescType),
    //     datasets: [
    //       {
    //         data: pieData.map((item) => item.totalExpenses),
    //         backgroundColor: ["#ed64a6", "#4c51bf", "#ffa426", "#48A5F4", "#FAC05E","#1af09e","#ad09a8","#ad094d","#f7ef07"],
    //       },
    //     ],
    //   },
    //   options: {
    //     maintainAspectRatio: false,
    //     responsive: true,
    //     title: {
    //       display: true,
    //       text: "Expense Distribution",
    //     },
    //   },
    // };




    const config = {
      type: "pie",
      data: {
        labels: pieData.map((item) => item.expenseDescType),
        datasets: [
          {
            data: pieData.map((item) => item.totalExpenses),
            backgroundColor: [ "#ffa426", "#4c51bf", "#48A5F4", "#FAC05E", "#1af09e", "#ad09a8", "#ad094d", "#f7ef07"],
          },
        ],  
      },
      options: {
        maintainAspectRatio: false,
        responsive: true,
        title: {
          display: true,
          text: "Expense Distribution",
        },
        plugins: {
          datalabels: {
            display: false,
            color: ['green', 'white', 'red', 'magenta', 'pink','teal'], // Font color for labels
            formatter: (value) => { // Custom label formatter function
              return  value ;
            },
            font: {
              weight: 'bold',
              size: 16, // Font size in pixels
              family:'Courier'
            },
            //anchor: 'end', // Label anchor position
            align: 'start', // Label alignment
            offset: -10, // Label offset from anchor
            padding: {
              top: 10,
              bottom: 10,
              left: 0,
              right: 0
            },
            labels: {
              title: {
                font: {
                  weight: 'bold'
                }
              }
            }
          }
        }
      }
    };
    





    const ctx = document.getElementById("pie-chart").getContext("2d");
    window.myPie = new Chart(ctx, config);
  }, [pieData]);

  return (
    <>
      <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded">
        <div className="rounded  mr-4 pl-4 mt-4 bg-transparent">
          <div className="flex flex-wrap items-center">
            <div className="relative w-full max-w-full flex-grow flex-1">
              {/* <h6 className="uppercase text-blueGray-400 mb-1 text-xs font-semibold">OVERVIEW</h6> */}
              <h2 className="text-blueGray-700 text-xl font-semibold">This Month Expense Distribution</h2>
              <div className="flex">
                <div className="mr-4">
                  <select
                    className="bg-white-800 text-black border border-black-600 rounded px-6 py-1 outline-none focus:outline-none w-32"
                    value={selectedYear}
                    onChange={(e) => setSelectedYear(parseInt(e.target.value, 10))}
                  >
                    {/* Populate with years */}
                    {Array.from({ length: 3 }, (_, i) => (
                      <option key={i} value={new Date().getFullYear() - i}>
                        {new Date().getFullYear() - i}
                      </option>
                    ))}
                  </select>
                </div>
                <div>
                  <select
                    className="bg-white-800 text-black border border-black-600 rounded px-3 py-1 outline-none focus:outline-none w-32"
                    value={selectedMonth}
                    onChange={(e) => setSelectedMonth(parseInt(e.target.value, 10))}
                  >
                    {/* Populate with months */}
                    {Array.from({ length: 12 }, (_, i) => (
                      <option key={i + 1} value={i + 1}>
                        {new Date(0, i).toLocaleString("en", { month: "long" })}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="p-4 flex-auto">
          {/* Chart */}
          <div className="relative h-350-px">
            <canvas id="pie-chart"></canvas>
          </div>
        </div>
      </div>
    </>
  );
}
